import React, { useState } from "react";
import { ChevronDown } from "lucide-react";

export default function FaqAccordion({ items, testidPrefix = "faq" }) {
  const [open, setOpen] = useState(0);
  return (
    <div className="mx-auto max-w-3xl divide-y divide-nek-border rounded-2xl border border-nek-border bg-white">
      {items.map((it, i) => {
        const isOpen = open === i;
        return (
          <div key={it.q} data-testid={`${testidPrefix}-item-${i}`}>
            <button
              type="button"
              onClick={() => setOpen(isOpen ? -1 : i)}
              aria-expanded={isOpen}
              data-testid={`${testidPrefix}-trigger-${i}`}
              className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left"
            >
              <span className="font-heading text-base font-bold text-nek-navy sm:text-lg">{it.q}</span>
              <ChevronDown className={`h-5 w-5 shrink-0 text-nek-blue transition-transform duration-300 ${isOpen ? "rotate-180" : ""}`} />
            </button>
            <div className={`grid overflow-hidden transition-all duration-300 ${isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"}`}>
              <div className="overflow-hidden">
                <p className="px-5 pb-5 text-[15px] leading-relaxed text-nek-gray">{it.a}</p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
